<template>
  <div class="tat-dashboard-container">
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard d-flex justify-content-between align-items-center"
          style="border-radius: 5px !important; padding: 5px 15px;"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand class="m-0">FF Export Billing Report</b-navbar-brand>
          <div class="d-flex align-items-center">
            <b-button
              variant="light"
              size="sm"
              class="mr-2 text-primary font-weight-bold"
              @click="visible = !visible"
            >
              <i class="fa fa-filter mr-1"></i> FILTERS
            </b-button>
            <b-button
              @click="exportTallyBillingExcel"
              size="sm"
              variant="success"
              class="mr-2 font-weight-bold"
              :disabled="isLoading"
            >
              <i class="fa fa-file-excel-o mr-1"></i> TALLY BILLING EXCEL
            </b-button>
            <b-button
              v-if="reportData.length > 0"
              @click="exportExcel"
              size="sm"
              variant="warning"
              class="font-weight-bold"
              :disabled="isLoading"
            >
              <i class="fa fa-file-excel-o mr-1"></i> EXPORT AS EXCEL
            </b-button>
          </div>
        </b-navbar>

          <b-collapse v-model="visible" id="collapse-filter">
            <b-card class="mt-2">
              <b-row>
                <b-col md="3">
                  <label>Client Name</label>
                  <model-list-select :list="$store.getters['common/getAllClientList']" id="clientFilter"
                    v-model="Filter.clientFilter" option-value="clientId" option-text="clientName"
                    placeholder="Select Client Name" @input="fetchReport(1)"
                    :disabled="isLoading" />
                </b-col>
                <b-col md="3">
                  <label>Date Range (Job Date)</label>
                  <date-range-picker
                    v-model="dateRange"
                    :locale-data="locale"
                    opens="left"
                  >
                    <div slot="input" slot-scope="picker">
                      {{ dateRange.startDate | moment }} -
                      {{ dateRange.endDate | moment }}
                    </div>
                  </date-range-picker>
                </b-col>
                <b-col md="3">
                  <label>Booking NO</label>
                  <b-form-input
                    v-model="Filter.booking_number"
                    placeholder="Search Booking No"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Container No</label>
                  <b-form-input
                    v-model="Filter.container_number"
                    placeholder="Search Container No"
                  ></b-form-input>
                </b-col>
              </b-row>

              <b-row class="mt-2">
                <b-col md="3">
                  <label>MBL No</label>
                  <b-form-input
                    v-model="Filter.MblNoFilter"
                    placeholder="Search MBL No"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>HBL No</label>
                  <b-form-input
                    v-model="Filter.HblNoFilter"
                    placeholder="Search HBL No"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Job No</label>
                  <b-form-input
                    v-model="Filter.assignmentFilter"
                    placeholder="Search Job No"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Months/Year</label>
                  <model-list-select
                    :list="dateStatusList"
                    v-model="Filter.dateStatusFilter"
                    option-value="inv"
                    option-text="int"
                    placeholder="Select Duration"
                  ></model-list-select>
                </b-col>
              </b-row>

              <b-row class="mt-2">
                <b-col md="3">
                  <label>Billing Status</label>
                  <model-list-select
                    :list="BillingStatusList"
                    v-model="Filter.isFinalBillingStatus"
                    option-value="inv"
                    option-text="int"
                    placeholder="Select Billing Status"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Invoice Status</label>
                  <model-list-select
                    :list="invoiceStatusList"
                    v-model="Filter.billingFilter"
                    option-value="inv"
                    option-text="int"
                    placeholder="Select Invoice Status"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Sob Status</label>
                  <model-list-select
                    :list="SOBStatusList"
                    v-model="Filter.SOBFilter"
                    option-value="inv"
                    option-text="int"
                    placeholder="Select SOB Status"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Prealert Status</label>
                  <model-list-select
                    :list="PrealertStatusList"
                    v-model="Filter.PrealertFilter"
                    option-value="inv"
                    option-text="int"
                    placeholder="Select Prealert Status"
                  ></model-list-select>
                </b-col>
              </b-row>

              <b-row class="mt-2">
                <b-col md="3">
                  <label>Shipping Line</label>
                  <model-list-select
                    :list="$store.getters['common/getAllShippingLineList']"
                    v-model="Filter.slineFilter"
                    option-value="shippingId"
                    option-text="shippingLine"
                    placeholder="Select Shipping Line"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Branch</label>
                  <model-list-select
                    :list="$store.getters['common/getAllBranchList']"
                    v-model="Filter.branchFilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Branch"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Line Inv Status</label>
                  <model-list-select
                    :list="lineInvoiceStatus"
                    v-model="Filter.line_inv_statusFilter"
                    option-value="inv"
                    option-text="int"
                    placeholder="Select Line Inv Status"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>BL Release Status</label>
                  <model-list-select
                    :list="mblInvoiceStatus"
                    v-model="Filter.liner_bl_release_statusFilter"
                    option-value="inv"
                    option-text="int"
                    placeholder="Select BL Release Status"
                  ></model-list-select>
                </b-col>
              </b-row>

              <b-row class="mt-3">
                <b-col md="3">
                  <b-form-checkbox v-model="Filter.filterBlanks">
                    Filter Blanks (Missing Milestones)
                  </b-form-checkbox>
                </b-col>
                <b-col md="2">
                  <b-form-checkbox v-model="Filter.highAlertOnly">
                    High Alert Only (>5 days from SOB)
                  </b-form-checkbox>
                </b-col>
                <b-col md="2">
                  <b-form-input type="number" v-model="Filter.highAlertDays" placeholder="Alert Days (>X)"></b-form-input>
                </b-col>
                <b-col md="6">
                  <b-form-input
                    v-model="Filter.search"
                    placeholder="Quick Search: Job No / MBL / Client"
                    @keyup.enter="fetchReport(1)"
                  ></b-form-input>
                </b-col>
              </b-row>

              <div class="mt-3 text-center">
                <b-button
                  size="sm"
                  @click="fetchReport(1)"
                  variant="outline-primary"
                  >Search</b-button
                >
                <b-button
                  size="sm"
                  class="ml-2"
                  @click="clearFilters"
                  variant="outline-info"
                  >Clear</b-button
                >
              </div>
            </b-card>
          </b-collapse>
        

        <div class="mt-3">
          <h5 class="text-muted pull-right">
            <small>{{ totalRows }} Entries</small>
          </h5>
        </div>

        <div class="table-responsive mt-2">
          <b-table
            show-empty
            stacked="md"
            :items="reportData"
            :fields="fields"
            :per-page="pageSize"
            hover
            bordered
            small
            class="mb-0"
            :busy="isLoading"
          >
            <!-- Job Details Column -->
            <template slot="jobDet" slot-scope="data">
              <div v-if="data.item" class="d-flex flex-column">
                <div class="font-weight-bold" :class="data.item.HighAlert ? 'text-danger' : ''">
                  {{ data.item.JobNo }}
                </div>
                <div class="mt-1">
                  <span class="badge badge-secondary">{{ data.item.JobDate }}</span>
                  <span class="badge badge-info ml-1">{{ data.item.JobType }}</span>
                </div>
                <div class="mt-1 small text-muted">
                  {{ data.item.Mode }} | {{ data.item.TransportType }}
                </div>
                <div class="mt-1 small">
                  <span class="text-muted">From:</span> {{ data.item.RaisedFrom }}
                  <span class="text-muted ml-1">By:</span> {{ data.item.RaisedBy }}
                </div>
                <div class="mt-1 small font-weight-bold">
                  {{ data.item.Vessel }} | {{ data.item.Voyage }}
                </div>
              </div>
              <div v-if="data.item" class="d-flex flex-column small" :style="data.item.TallyPendingHighlight ? 'background-color: #fff3cd; padding: 2px; border-radius: 4px;' : ''">
                <div class="font-weight-bold text-success">Inv: {{ data.item.TallyInvoiceNo || 'N/A' }}</div>
                <div v-if="data.item.TallyPendingHighlight" class="text-danger font-weight-bold small">PENDING FROM TALLY</div>
                <div>Date: {{ data.item.TallyInvoiceDate || 'N/A' }}</div>
                <div class="mt-1" v-if="data.item.RInvNo !== 'N/A'">
                  <div class="text-muted">Rev: {{ data.item.RInvNo }}</div>
                  <div class="text-muted">RevDate: {{ data.item.ReverseTallyInvDate }}</div>
                </div>
                <div class="mt-1 text-info font-weight-bold">
                  {{ data.item.TallyBillingClosedStatus }}
                </div>
                <div class="mt-1 small" v-if="data.item.ExecutionInvoices">
                  <strong>Ex.Inv:</strong> {{ truncateText(data.item.ExecutionInvoices, 30) }}
                </div>
              </div>
              <b-button class="mt-2" style="font-size: 0.675rem" size="sm" @click="showDocModal(data.item)"
                  variant="outline-info">Summary & Documents</b-button>
              <InvExpSummary v-if="data.item.JobId"
                  :PMC_title="'Inv Exp Summary Job No - ' + data.item.JobNo"
                  :PMC_JOBID="data.item.JobId" :PMC_JOBNO="data.item.JobNo"
                  :PMC_JOBDATE="''" :PMC_JOBTYPE="''" :PMC_AgentType="''"
                  :PMC_Client="''" :PMC_Sline="''" />
              <Assignment-Summary :title="'Shipment Summary Tracking - '" :fk_all_module_id="data.item.JobId"
                :jb_series="data.item.JobNo" />
              <ContainerSummary v-if="data.item.JobId"
                :PMC_title="'Container Summary Job No - ' + data.item.JobNo"
                :PMC_JOBID="data.item.JobId" :PMC_JOBNO="data.item.JobNo" :PMC_JOBDATE="''"
                :PMC_JOBTYPE="''" :PMC_AgentType="''" :PMC_Client="''" :PMC_Sline="''" />
              <JobWisePaymentsDetails
                  v-if="data.item.JobId"
                  :JobId="Number(data.item.JobId)"
                  :JobNo="data.item.JobNo"
                  />
              <RejectInvTallyBillSummary v-if="data.item.JobId" :PMC_title="'Invoice Rejection Log Summary Job No - ' + data.item.JobNo
                " :PMC_JOBID="data.item.JobId" :PMC_JOBNO="data.item.JobNo" :PMC_JOBDATE="''"
                :PMC_JOBTYPE="''" :PMC_Client="''" :PMC_Sline="''" />
                 <WebhookLogSummary v-if="data.item.JobId"
                :show-trigger-button="true"
                :PMC_title="'Webhook Log'"
                :PMC_JOBID="data.item.JobId" :PMC_JOBNO="data.item.JobNo"
                :PMC_JOBDATE="''" :PMC_JOBTYPE="''" :PMC_AgentType="''"
                :PMC_Client="''" :PMC_Sline="''" />
              <AssignmentSplitMergeSummary v-if="data.item.JobId"
                :PMC_title="'Assignment Split/Merge/Move Summary'"
                :PMC_JOBID="data.item.JobId" :PMC_JOBNO="data.item.JobNo"
                :PMC_JOBDATE="''" :PMC_JOBTYPE="''" :PMC_AgentType="''"
                :PMC_Client="''" :PMC_Sline="''" />
                 <BookingTrack :containerArr="data.item.FreightContainers"
                :slineName="data.item.ShippingLine"
                :clientName="data.item.ClientName"
                :modal_title="`Container Movement Booking No: ${data.item.BookingNo} Job No - ${data.item.JobNo} Client: ${data.item.ClientName}`"
                :JOBNO="data.item.JobNo" :shipment_id="Number(0)" :subscription_id="Number(0)" :fk_sub_track_id="Number(0)"
                :fk_all_module_id="Number(data.item.JobId)" :fk_booking_id="Number(data.item.fk_booking_id)"
                :fk_container_id="Number(0)" :booking_number="data.item.BookingNo" :container_number="''" />
            </template>

            <!-- Client/Sline Column -->
            <template slot="clientDet" slot-scope="data">
              <div v-if="data.item" class="d-flex flex-column">
                <div class="font-weight-bold">{{ truncateText(data.item.ClientName, 25) }}</div>
                <div class="mt-1 small text-muted">Line: {{ truncateText(data.item.ShippingLine, 20) }}</div>
                <div class="mt-1 small font-weight-bold">B.No: {{ data.item.BookingNo || 'N/A' }}</div>
                <div class="mt-1 small text-muted">BRF: {{ data.item.BrfNo || 'N/A' }}</div>
                <div class="mt-1 small text-muted">Enq: {{ data.item.EnqBrfNo || 'N/A' }}</div>
              </div>
            </template>

            <!-- Location Details Column -->
            <template slot="locDet" slot-scope="data">
              <div v-if="data.item" class="d-flex flex-column">
                <div class="d-flex flex-column align-items-start">
                  <span class="badge badge-light mb-1" v-b-tooltip.hover :title="data.item.Por">{{ getPortCode(data.item.Por) }}</span>
                  <span class="badge badge-light mb-1" v-b-tooltip.hover :title="data.item.Pol">{{ getPortCode(data.item.Pol) }}</span>
                  <span class="badge badge-light" v-b-tooltip.hover :title="data.item.Pod">{{ getPortCode(data.item.Pod) }}</span>
                </div>
                <div class="mt-1 small text-muted">FPOD: {{ getPortCode(data.item.Fpod) }}</div>
              </div>
            </template>

            <!-- Billing & Accounts Column -->
            <template slot="billDetails" slot-scope="data">
              <div v-if="data.item" class="d-flex flex-column small">
                <div class="d-flex justify-content-between mb-1">
                  <span class="text-muted">Type:</span>
                  <span class="badge badge-info">{{ data.item.billingType }}</span>
                </div>
                <div class="d-flex justify-content-between mb-1">
                  <span class="text-muted">Sent:</span>
                  <span class="badge badge-secondary">{{ data.item.SentToAccountsDate || 'N/A' }}</span>
                </div>
                <div class="mt-1 small">
                  <div class="d-flex justify-content-between">
                    <span class="text-muted">OF Pay:</span>
                    <span>{{ data.item.OfFirstPaymentDate || 'N/A' }}</span>
                  </div>
                  <div class="d-flex justify-content-between">
                    <span class="text-muted">Line Pay:</span>
                    <span>{{ data.item.oe_sline_inv_pay_date || 'N/A' }}</span>
                  </div>
                </div>
                <hr class="my-1">
                <div class="font-weight-bold mb-1">Financials:</div>
                <div class="d-flex justify-content-between text-danger">
                  <span>Expense:</span>
                  <span>{{ data.item.Expense || 0 }}</span>
                </div>
                <div class="d-flex justify-content-between text-success">
                  <span>Income:</span>
                  <span>{{ data.item.Income || 0 }}</span>
                </div>
                <div class="d-flex justify-content-between font-weight-bold" :class="data.item.Profit >= 0 ? 'text-primary' : 'text-danger'">
                  <span>Profit:</span>
                  <span>{{ data.item.Profit || 0 }}</span>
                </div>
              </div>
            </template>

            <!-- Submissions Column -->
            <template slot="subDetails" slot-scope="data">
              <div v-if="data.item" class="d-flex flex-column small">
                <div><strong>Push To Accounts Date:</strong> {{ data.item.PushToAccountsDate || 'N/A' }}</div>
                <div><strong>VGM:</strong> {{ data.item.VgmSubmissionDateActual || 'N/A' }}</div>
                <div class="text-muted mb-1">Due: {{ data.item.VgmDueDate || 'N/A' }}</div>
                
                <div><strong>SI:</strong> {{ data.item.SiSubmissiondateActual || 'N/A' }}</div>
                <div class="text-muted mb-1">Due: {{ data.item.SiDueDate || 'N/A' }}</div>
                
                <div><strong>TR:</strong> {{ data.item.TrSubmissiondateActual || 'N/A' }}</div>
                <div class="text-muted mb-1">Due: {{ data.item.TrDueDate || 'N/A' }}</div>
                
                <div><strong>H/O:</strong> {{ data.item.HandoverDateActual || 'N/A' }}</div>
                <div><strong>GateIn Due:</strong> {{ data.item.GateInDueDate || 'N/A' }}</div>
              </div>
            </template>

            <!-- Hbl/Mbl Details Column -->
            <template slot="blDetails" slot-scope="data">
              <div v-if="data.item" class="d-flex flex-column small">
                <div class="font-weight-bold">MBL: {{ data.item.MblNo || 'N/A' }}</div>
                <div class="font-weight-bold">MBL Date: {{ data.item.MblDate || 'N/A' }}</div>
                <div class="font-weight-bold">MBL Release Date: {{ data.item.MblReleaseDate || 'N/A' }}</div>
                <div class="font-weight-bold">First HBL Date: {{ data.item.FirstHblDate || 'N/A' }}</div>
                <div class="font-weight-bold">Linear BL Upload Date: {{ data.item.LinearBlUploadDate || 'N/A' }}</div>
                <div class="font-weight-bold">HBL: {{ data.item.HblNo || 'N/A' }}</div>
                <div class="mt-1 text-muted">Type: {{ data.item.blType || 'N/A' }}</div>
                <div class="d-flex gap-1 mt-1">
                  <span class="badge badge-light">M:{{ data.item.frghtTermsMbl || 'N/A' }}</span>
                  <span class="badge badge-light">H:{{ data.item.frghtTermsHbl || 'N/A' }}</span>
                </div>
              </div>
            </template>

            <!-- Container Details Column -->
            <template slot="contDetails" slot-scope="data">
              <div v-if="data.item" class="d-flex flex-column small">
                <div class="text-wrap font-weight-bold">{{ data.item.FreightContainers || 'N/A' }}</div>
                <div class="mt-1">{{ data.item.FreightContainersType }} ({{ data.item.MultipleContainerNo }})</div>
                <div class="text-muted">{{ data.item.StuffingType }} | {{ data.item.FclLcl }}</div>
                <hr class="my-1">
                <div><strong>S.Inv:</strong> {{ data.item.SINVNO || 'N/A' }}</div>
                <div><strong>S.Bill:</strong> {{ data.item.SBILLNO || 'N/A' }}</div>
                <div><strong>Seals (C/L):</strong></div>
                <div class="text-wrap">{{ data.item.CUST_SEAL_NO || 'N/A' }} / {{ data.item.LINE_SEAL_NO || 'N/A' }}</div>
              </div>
            </template>

            <!-- Dates Column -->
            <template slot="dates" slot-scope="data">
              <div v-if="data.item" class="d-flex flex-column small">
                <div class="font-weight-bold">SOB Dates:</div>
                <div class="ml-1">Sys SOB: {{ data.item.SysSOB || 'N/A' }}</div>
                <div class="ml-1 text-primary">SOB: {{ data.item.SOB || 'N/A' }}</div>
                <hr class="my-1">
                <div class="d-flex justify-content-between">
                  <span class="font-weight-bold">MBL Rel:</span>
                  <span>{{ data.item.MblDate || 'N/A' }}</span>
                </div>
              </div>
            </template>

            <!-- Status Column -->
            <template slot="status" slot-scope="data">
              <div v-if="data.item" class="d-flex flex-column gap-1 small">
                <div class="badge badge-primary mb-1 text-wrap">{{ data.item.status_verbose }}</div>
                <div class="d-flex flex-wrap gap-1">
                  <span class="badge badge-info">BL: {{ data.item.BlReleaseStatus }}</span>
                  <span class="badge badge-warning">Sline Pay: {{ data.item.SlinePaymentStatus }}</span>
                  <span class="badge badge-secondary">Prealert: {{ data.item.PrealertStatus }}</span>
                  <span class="badge badge-dark">FF Inv: {{ data.item.FFInvStatus }}</span>
                  <span class="badge badge-dark">CC Inv: {{ data.item.CCInvStatus }}</span>
                  <span class="badge badge-dark">TPT Inv: {{ data.item.TPTInvStatus }}</span>
                  <span class="badge badge-light border">Line Inv: {{ data.item.LineInvStatus }}</span>
                  <span class="badge badge-light border">Inv Side: {{ data.item.InvoiceSideStatus }}</span>
                  <span class="badge badge-light border">Tb Side: {{ data.item.TallyBillingSideStatus }}</span>
                </div>
                <div class="d-flex flex-wrap gap-1 mt-1">
                  <span class="badge badge-danger" v-if="data.item.IsRollover !== 'Not RollOvers'">Rollover: {{ data.item.IsRollover }}</span>
                  <span class="badge badge-success" v-if="data.item.IsManifestation === 'Yes'">Manifest: Yes</span>
                  <span class="badge badge-info">Billing: {{ data.item.BillingStatus }}</span>
                  <span class="badge badge-secondary">Type: {{ data.item.IsBillingTypeStatus }}</span>
                </div>
                <div class="mt-1 font-weight-bold">
                  <span class="text-muted">Terms:</span> {{ data.item.DeliveryTerms || 'N/A' }} | {{ data.item.DeliveryMode || 'N/A' }}
                </div>
                <div class="mt-1">
                  <span class="text-muted">Overseas:</span> <span class="badge badge-info">{{ data.item.closedOverseasStatus }}</span>
                </div>
                <div class="small text-danger font-weight-bold" v-if="data.item.JobDeleteStatus !== 'Not Deleted'">
                  {{ data.item.JobDeleteStatus }}
                </div>
              </div>
            </template>

            <!-- Billing Info (TallyInvoiceNo) Column -->
            <template slot="TallyInvoiceNo" slot-scope="data">
              <div v-if="data.item" class="d-flex flex-column small" :style="data.item.TallyPendingHighlight ? 'background-color: #fff3cd; padding: 2px; border-radius: 4px;' : ''">
                <div class="font-weight-bold text-success">Inv: {{ data.item.TallyInvoiceNo || 'N/A' }}</div>
                <div v-if="data.item.TallyPendingHighlight" class="text-danger font-weight-bold small">PENDING FROM TALLY</div>
                <div>Date: {{ data.item.TallyInvoiceDate || 'N/A' }}</div>
                <div class="mt-1" v-if="data.item.RInvNo !== 'N/A'">
                  <div class="text-muted">Rev: {{ data.item.RInvNo }}</div>
                  <div class="text-muted">RevDate: {{ data.item.ReverseTallyInvDate }}</div>
                </div>
                <div class="mt-1 text-info font-weight-bold">
                  {{ data.item.TallyBillingClosedStatus }}
                </div>
                <div class="mt-1 small" v-if="data.item.ExecutionInvoices">
                  <strong>Ex.Inv:</strong> {{ truncateText(data.item.ExecutionInvoices, 30) }}
                </div>
              </div>
            </template>

            <!-- High Alert Column -->
            <template slot="HighAlert" slot-scope="data">
              <div v-if="data.item" class="text-center">
                <b-badge v-if="data.item.HighAlert" variant="danger" class="p-2">
                  <i class="fa fa-exclamation-triangle mr-1"></i> HIGH ALERT
                  <div class="mt-1 small">{{ data.item.HighAlertDays }} Days from SOB</div>
                </b-badge>
                <b-badge v-else variant="success">Normal</b-badge>
              </div>
            </template>

          </b-table>
        </div>

        <b-modal size="xl" id="doc" class="modal-dialog-doc" no-close-on-esc no-close-on-backdrop ref="doc-modal"
        hide-footer :title="'Assignment Summary & Documents - ' + JOBSERIES">
        <div v-if="ALLMODULE">
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal">Close
        </b-button>
      </b-modal>

        <div class="mt-3">
          <b-pagination
            limit="10"
            align="center"
            v-model="currentPage"
            :per-page="pageSize"
            :total-rows="totalRows"
            @change="onPageChange($event)"
          ></b-pagination>
        </div>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import moment from "moment";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_NODE_BASE } from "../../helper/constant.js";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import BillingReportService from "../../services/BillingReportService";
import CustomLoader from "../common/customLoader.vue";
import * as XLSX from "xlsx";

import DocForm from "../../component/allModuleForm/docLibrary.vue";
import AddMessage from "../allModuleForm/addMessage.vue";
import AssignmentSummary from "../common/assignmentSummary.vue";
import CommonService from "../../services/CommonService.js";
import FilterAgencyModal from "../allModuleForm/filterAgencyModal.vue";
import FilterCBModal from "../allModuleForm/filterCBModal.vue";
import ClientCard from "../common/clientCard.vue";
import ShipmentTrackCard from "../common/ShipmentTrackCard.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import InvExpSummary from "../common/moduleBasedInvExpSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import ContaierWebLogSummary from "../common/moduleBasedContaierWebLogSummary.vue";
import WebhookLogSummary from "../common/WebhookLogSummary.vue";
import AssignmentSplitMergeSummary from "../common/AssignmentSplitMergeSummary.vue";
import RejectInvTallyBillSummary from "../common/moduleBasedRejectInvTallyBillSummary.vue";
import MSDeleteRequest from "../common/MSDeleteRequest.vue";
import BookingTrack from "../consoleBooking/bookingTrack.vue";

export default {
  name: "FFExportBillingReport",
  components: {
    ModelListSelect,
    CustomLoader,
    DateRangePicker,
     DocForm,
    AddMessage,
    AssignmentSummary,
    FilterAgencyModal,
    FilterCBModal,
    ClientCard,
    ShipmentTrackCard,
    ContainerSummary,
    InvExpSummary,
    JobWisePaymentsDetails,
    ContaierWebLogSummary,
    WebhookLogSummary,
    AssignmentSplitMergeSummary,
    BookingTrack,
    RejectInvTallyBillSummary,
    MSDeleteRequest,
  },
  filters: {
    moment(date) {
      return date ? moment(date).format("DD-MM-YYYY") : "";
    },
  },
  data() {
    return {
       ALLMODULE: "",
      JOBSERIES: "",
      isLoading: false,
      visible: false,
      reportData: [],
      totalRows: 0,
      currentPage: 1,
      pageSize: 50,
      dateRange: {
        startDate: moment().startOf("month").format("YYYY-MM-DD"),
        endDate: moment().endOf("month").format("YYYY-MM-DD"),
      },
      Filter: {
        clientFilter: "",
        search: "",
        filterBlanks: false,
        highAlertOnly: true,
        booking_number: "",
        container_number: "",
        MblNoFilter: "",
        HblNoFilter: "",
        assignmentFilter: "",
        dateStatusFilter: "0",
        isFinalBillingStatus: "",
        billingFilter: "",
        SOBFilter: "3",
        PrealertFilter: "3",
        slineFilter: "",
        branchFilter: "",
        liner_bl_release_statusFilter: "",
        line_inv_statusFilter: "",
        highAlertDays: "",
      },
      dateStatusList: [
        { inv: "125", int: "4 Month" },
        { inv: "186", int: "6 Month" },
        { inv: "248", int: "8 Month" },
        { inv: "300", int: "10 Month" },
        { inv: "367", int: "1 Year" },
        { inv: "734", int: "2 Year" },
        { inv: "0", int: "Global ALL" },
      ],
      BillingStatusList: [
        { inv: "1", int: "Completed" },
        { inv: "0", int: "Pending" },
        { inv: "2", int: "All" },
      ],
      invoiceStatusList: [
        { inv: "1", int: "In-Progress" },
        { inv: "2", int: "Sent to Accounts" },
        { inv: "3", int: "Billing Not Started" },
        { inv: "4", int: "Not To Be Billed" },
        { inv: "", int: "All" },
      ],
      PrealertStatusList: [
        { inv: "1", int: "Yes" },
        { inv: "2", int: "No" },
        { inv: "3", int: "All" },
      ],
      SOBStatusList: [
        { inv: "1", int: "Sailed" },
        { inv: "2", int: "Not Sailed" },
        { inv: "3", int: "All" },
      ],
      lineInvoiceStatus: [
        { int: "Not Received from Line", inv: "1" },
        { int: "Not Initiated", inv: "0" },
        { int: "Paid", inv: "2" },
        { int: "Dispute Raised", inv: "3" },
        { int: "Send for Payment", inv: "4" }
      ],
      mblInvoiceStatus: [
        { int: "Released", inv: "1" },
        { int: "Sailed - NOT RELEASED", inv: "0" },
        { int: "NOT RELEASED", inv: "2" },
      ],
      locale: {
        direction: "ltr",
        format: "dd-mm-yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: moment.weekdaysMin(),
        monthNames: moment.monthsShort(),
        firstDay: 1,
      },
      fields: [
        { key: "jobDet", label: "Job Details", thStyle: { width: "150px" } },
        { key: "dates", label: "Dates", thStyle: { width: "150px" } },
        { key: "HighAlert", label: "High Alert", thStyle: { width: "100px" } },
        { key: "clientDet", label: "Client/Sline", thStyle: { width: "150px" } },
        { key: "locDet", label: "Location Details", thStyle: { width: "130px" } },
        { key: "billDetails", label: "Billing & Accounts", thStyle: { width: "180px" } },
        { key: "subDetails", label: "Submissions", thStyle: { width: "130px" } },
        { key: "blDetails", label: "Hbl/Mbl Details", thStyle: { width: "150px" } },
        { key: "contDetails", label: "Container Details", thStyle: { width: "150px" } },
        { key: "status", label: "Status", thStyle: { width: "200px" } },
        { key: "TallyInvoiceNo", label: "Billing Info", thStyle: { width: "180px" } },
      ],
    };
  },
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    this.$store.dispatch("setCurrentRoute", this.$router.history.current.fullPath);
    if (!globalPermissionStatus("Sea Freight")) {
      this.$router.push("/dashboard");
    }
    this.$store.dispatch("common/setAllClientList", JSON.stringify({ itemCode: "ClientList" }));
    this.$store.dispatch("common/setAllShippingLineList", JSON.stringify({ itemCode: "ShippingLineList" }));
    this.$store.dispatch("common/setAllBranchList", JSON.stringify({ filter: "BranchList", active: "all" }));
    this.initDateRange();
  },
  mounted() {
    this.fetchReport(1);
  },
  methods: {
     showDocModal(item) {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.JobId;
      this.JOBSERIES = item.JobNo;
      console.log(this.ALLMODULE);
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    fetchReport(page = 1) {
      this.isLoading = true;
      this.currentPage = page;
      
      const payload = {
        page: this.currentPage,
        pageSize: this.pageSize,
        dateRange: {
          startDate: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
          endDate: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        },
        Filter: Object.assign({}, this.Filter),
      };

      BillingReportService.getFFExportBillingReport(payload)
      .then(response => {
        if (response.data && response.data.status) {
          this.reportData = response.data.data;
          this.totalRows = response.data.pagination.total;
        }
      })
      .catch(error => {
        console.error("Error fetching report:", error);
      })
      .finally(() => {
        this.isLoading = false;
      });
    },
    onPageChange(page) {
      this.fetchReport(page);
    },
    clearFilters() {
      this.Filter = {
        clientFilter: "",
        search: "",
        filterBlanks: false,
        highAlertOnly: false,
        booking_number: "",
        container_number: "",
        MblNoFilter: "",
        HblNoFilter: "",
        assignmentFilter: "",
        dateStatusFilter: "0",
        isFinalBillingStatus: "",
        billingFilter: "",
        SOBFilter: "3",
        PrealertFilter: "3",
        slineFilter: "",
        branchFilter: "",
        liner_bl_release_statusFilter: "",
        line_inv_statusFilter: "",
        highAlertDays: "",
      };
      this.initDateRange();
      this.fetchReport(1);
    },
    initDateRange() {
      const today = new Date();
      const currentMonth = today.getMonth();
      const currentYear = today.getFullYear();

      let startYear, endYear;

      if (currentMonth >= 3) { // April (3) or later
        startYear = currentYear;
        endYear = currentYear + 1;
      } else { // Jan, Feb, Mar
        startYear = currentYear - 1;
        endYear = currentYear;
      }

      const firstDay = new Date(startYear, 3, 1); // April 1st
      const lastDay = new Date(endYear, 2, 31); // March 31st

      this.dateRange = { startDate: firstDay, endDate: lastDay };
    },
    async exportTallyBillingExcel() {
      this.isLoading = true;
      try {
        const response = await BillingReportService.getTallyBillingExcelReport();
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Tally_Billing_Report_${moment().format("YYYY-MM-DD")}.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Tally Billing Excel Export Error:", error);
        alert("Error downloading Tally Billing Excel. Please try again.");
      } finally {
        this.isLoading = false;
      }
    },
    async exportExcel() {
      this.isLoading = true;
      let allData = [];
      let page = 1;
      const pageSize = 100;
      let totalPages = 1;

      // Date columns returned as "DD-MM-YYYY" strings from the API.
      // XLSX.utils.json_to_sheet writes them as text by default, which breaks
      // Excel's date filter. Converting them to JS Date objects + cellDates:true
      // makes Excel treat them as proper date serial numbers.
      const DATE_KEYS = [
        "JobDate", "SOB", "SOB_ASSIGNMENT", "SOB_OI", "SOB_CONSOLE",
        "SysSOB", "SysETA_estimated", "MblDate", "MblReleaseDate",
        "PushToAccountsDate", "TallyInvoiceDate", "SlinePaymentRequestDate",
        "SlinePaymentDate", "LinearBlUploadDate", "FirstHblDate",
        "EtaDestinationEstimated", "EtaDestinationActual",
        "EtaLoadPortInitial", "EtaLoadPortActual",
        "OfFirstPaymentDate", "oe_sline_inv_pay_date",
        "VgmSubmissionDateActual", "SiSubmissiondateActual",
        "TrSubmissiondateActual", "HandoverDateActual",
        "SiDueDate", "VgmDueDate", "TrDueDate", "GateInDueDate",
      ];

      const parseDDMMYYYY = (str) => {
        if (!str || str === "No Sent") return null;
        const parts = str.split("-");
        if (parts.length !== 3) return null;
        const [dd, mm, yyyy] = parts;
        const d = new Date(`${yyyy}-${mm}-${dd}`);
        return isNaN(d.getTime()) ? null : d;
      };

      try {
        do {
          const payload = {
            page: page,
            pageSize: pageSize,
            dateRange: {
              startDate: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
              endDate: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
            },
            Filter: Object.assign({}, this.Filter),
          };

          const response = await BillingReportService.getFFExportBillingReport(payload);
          if (response.data && response.data.status) {
            allData = allData.concat(response.data.data);
            totalPages = response.data.pagination.pageCount;
            page++;
          } else {
            break;
          }
        } while (page <= totalPages);

        if (allData.length > 0) {
          // Convert DD-MM-YYYY strings → real JS Date objects
          const convertedData = allData.map((item) => {
            const row = Object.assign({}, item);
            DATE_KEYS.forEach((key) => {
              if (row[key] && typeof row[key] === "string") {
                const parsed = parseDDMMYYYY(row[key]);
                if (parsed) row[key] = parsed;
              }
            });
            return row;
          });

          // cellDates:true tells SheetJS to write Date objects as Excel date serials
          const worksheet = XLSX.utils.json_to_sheet(convertedData, { cellDates: true });

          // Apply "DD-MM-YYYY" number format to every date column so they display
          // in the same format users are familiar with, while still being real dates.
          const range = XLSX.utils.decode_range(worksheet["!ref"] || "A1");
          const header = allData.length > 0 ? Object.keys(allData[0]) : [];
          DATE_KEYS.forEach((key) => {
            const colIndex = header.indexOf(key);
            if (colIndex === -1) return;
            for (let R = range.s.r + 1; R <= range.e.r; R++) {
              const cellAddr = XLSX.utils.encode_cell({ r: R, c: colIndex });
              const cell = worksheet[cellAddr];
              if (cell && cell.t === "d") {
                cell.z = "dd-mm-yyyy";
              }
            }
          });

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "FF_Billing_Report");
          XLSX.writeFile(workbook, `FF_Export_Billing_Report_${moment().format("YYYY-MM-DD")}.xlsx`, { cellDates: true });
        }
      } catch (error) {
        console.error("Excel Export Error:", error);
        alert("Error exporting Excel. Please check console for details.");
      } finally {
        this.isLoading = false;
      }
    },
    truncateText(text, maxLength) {
      if (!text) return '';
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    },
    getPortCode(portName) {
      if (!portName) return '';
      const parts = portName.split(',');
      return parts[parts.length - 1].trim() || portName.substring(0, 6);
    },
  },
};
</script>

<style>
.tat-dashboard-container {
  padding: 15px;
}

.gap-1 {
  gap: 0.25rem;
}

/* Custom badge sizes for better visibility */
.badge-sm {
  font-size: 0.6rem;
  padding: 0.2rem 0.4rem;
}

/* Standardize all font sizes to 10px */
.b-table th,
.b-table td,
.badge,
.badge-sm,
small,
.text-muted,
.font-weight-bold,
h6,
.b-table,
.b-table * {
  font-size: 0.625rem !important;
}

.b-table td {
  vertical-align: top;
  padding: 0.5rem !important;
}

/* Neutral color scheme */
.badge-secondary {
  background-color: #6c757d !important;
  color: #ffffff !important;
}

.badge-light {
  background-color: #f8f9fa !important;
  color: #495057 !important;
  border: 1px solid #dee2e6;
}

.mainCardBG {
  background-color: #ffffff;
  border: 1px solid #e3e6f0;
}

.formCard {
  background-color: #4e73df !important;
}

.text-wrap {
  word-wrap: break-word;
  white-space: normal;
}
</style>



// WEBPACK FOOTER //
// ffExportBillingReport.vue?0d7828eb